/* eslint-disable import/no-default-export */

import { Button, Input } from '@insify/design-system/components';
import { textMdSemibold } from '@insify/design-system/typography';
import { useState } from 'react';

import { useGetCoiLink } from '../../api/queries/useGetCoiLink';
import { usePoliciesForCustomer } from '../../api/queries/usePoliciesForCustomer';
import { CertificateButton } from '../CertificateButton';

import * as styles from './Impersonate.module.css';

import type { Coverage } from '../../types/Policy';

export const Impersonate: React.FC = () => {
  const [customerId, setCustomerId] = useState('');
  const { refetch: fetchPolicies, data: policies = [], isFetching } = usePoliciesForCustomer(customerId);
  const handleClick = async () => {
    await fetchPolicies();
  };

  return (
    <div className={styles.mainContent}>
      <form>
        <Input
          type='text'
          id='customerId'
          name='customerId'
          className={styles.input}
          label={'customerId'}
          onChange={(e) => setCustomerId(e.target.value.trim())}
        />

        <Button
          trackingId='impersonate-customer-id'
          type='button'
          kind='primary'
          className={styles.submitButton}
          loading={isFetching}
          onClick={handleClick}
        >
          Apply
        </Button>
      </form>
      <section>
        {policies
          .flatMap((policy) => policy.coverages)
          .map((coverage) => (
            <FRCoverage key={coverage.policyNumber + coverage.title} customerId={customerId} coverage={coverage} />
          ))}
      </section>
    </div>
  );
};

const FRCoverage: React.FC<{ coverage: Coverage; customerId: string }> = ({ coverage, customerId }) => {
  const [extra, setExtra] = useState({ company: '', represent: '', position: '', text: '' });
  const { mutateAsync: getCoiLink, isPending } = useGetCoiLink();

  const isDisabled = extra.company.length < 3 || extra.represent.length < 3 || extra.text.length < 5;
  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isDisabled) return;

    if (window.confirm('Are you sure that you want update the customer COI?')) {
      const pdfLink = await getCoiLink({
        coverage: coverage.title,
        policyUuid: coverage.policyId,
        customerUuid: customerId,
        extra,
      });
      window.open(pdfLink, '_blank') || window.location.assign(pdfLink);
    }
  };

  return (
    <form className={styles.extraForm} onSubmit={onSubmit} key={coverage.policyNumber + coverage.title}>
      <label className={styles.extraLabel}>
        <span className={textMdSemibold}>Policy#: </span> {coverage.policyNumber}
      </label>
      <label>
        <span className={textMdSemibold}>Coverage: </span> {coverage.title}
      </label>
      <div className={styles.extraData}>
        <Input
          type='text'
          id={'extra_company' + coverage.policyNumber + coverage.title}
          name='extra_compnay'
          className={styles.input}
          label={'Habilité par'}
          onChange={(e) => setExtra((cur) => ({ ...cur, company: e.target.value.trim() }))}
        />
        <Input
          type='text'
          id={'extra_representative' + coverage.policyNumber + coverage.title}
          name='extra_representative'
          className={styles.input}
          label={'Représenté par'}
          onChange={(e) => setExtra((cur) => ({ ...cur, represent: e.target.value.trim() }))}
        />
        <Input
          type='text'
          id={'extra_position' + coverage.policyNumber + coverage.title}
          name='extra_position'
          className={styles.input}
          label={'Qualité du représentant'}
          onChange={(e) => setExtra((cur) => ({ ...cur, position: e.target.value.trim() }))}
        />
        <Input
          type='text'
          id={'extra_number' + coverage.policyNumber + coverage.title}
          name='extra_number'
          className={styles.input}
          label={'Carte professionnelle n°'}
          onChange={(e) => setExtra((cur) => ({ ...cur, text: e.target.value.trim() }))}
        />
      </div>

      <div className={styles.buttons}>
        <Button
          trackingId='impersonate-generate-coi'
          type='submit'
          kind='primary'
          className={styles.submitButton}
          loading={isPending}
          disabled={isDisabled}
        >
          Generate Customized COI
        </Button>

        {!isPending && <CertificateButton coverage={coverage} customerUuid={customerId} />}
      </div>
    </form>
  );
};
